import { render, staticRenderFns } from "./InfoSources.vue?vue&type=template&id=661b8793"
import script from "./InfoSources.vue?vue&type=script&lang=js"
export * from "./InfoSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports